module.exports = __webpack_public_path__ + "img/buttonDownIcon.710e4afe.svg";